
import { Controller } from "stimulus"
import { useIntersection, useMutation } from 'stimulus-use'

export default class extends Controller {
  connect() {
    useIntersection(this)
    useMutation(this, { attributes: true, childList: false, subtree: false })
    this.load()
  }

  disappear() {
    if (this.data.has('reload-on-disappear'))
      this.load()
  }

  mutate(entries) {
    for (const mutation of entries) {
      if (mutation.type === 'attributes') {
        if (mutation.attributeName == 'data-content-loader-url')
          this.load()
      }
    }
  }

  load() {
    if (this.data.has('show-loader')){
      initBlockUI($(this.element))
    }
    fetch(this.data.get("url"))
      .then(response => response.text())
      .then(html => {
        this.element.innerHTML = html
      })
  }

}
